module.exports = __webpack_public_path__ + "static/media/clustering.efc32491.png";